import { useCallback, useState } from "react";
import { getApiUrl } from "src/environment";
import {
  getApiAuthData,
  getDateTimeRecord,
  parseErrorMessage,
  redirectToLogin,
} from "src/utils";
import { Notification } from "src/utils/Notification";


interface IGetFileProps {
  request: string;
  body?: Record<string, any>;
  fileName?: string;
}

export const useGetFile = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getFile = useCallback(
    async ({ request, body, fileName = "download" }: IGetFileProps) => {
      setIsLoading(true);

      try {
        const response = await fetch(getApiUrl(), {
          method: "POST",
          body: JSON.stringify({
            request,
            _app: true,
            ...getApiAuthData(),
            ...body,
            dto: getDateTimeRecord(),
          }),
        });

        if (!response.ok) {
          throw new Error(`Server Error Occured! Code:${response.status}`);
        }

        const contentType = response.headers.get("content-type")?.toLowerCase();
        if (contentType?.includes("application/json")) {
          const result = await response.json();

          if (result?.logout) {
            redirectToLogin();
            throw new Error("error in get");
          }

          if (result?.error) {
            throw new Error(
              typeof result.error === "string"
                ? result.error
                : "Something went wrong.",
            );
          }

          return result;
        }

        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);

        return blob;
      } catch (error) {
        Notification("Error", parseErrorMessage(String(error)), "red");
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  return { getFile, isLoading };
};
